import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = !!(SUPABASE_URL && SUPABASE_ANON_KEY);

if (!isSupabaseConfigured) {
  // eslint-disable-next-line no-console
  console.warn(
    '[NewsWave Admin] Missing Supabase configuration. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env.local — auth and API calls will fail until you do.',
  );
}

// `createClient('', '', ...)` throws synchronously at module load, which
// would crash the entire admin-web bundle before App.tsx mounts and leave
// the user staring at a white screen. Construct the client only when both
// env vars are present; consumers read `isSupabaseConfigured` first and
// the top-level App renders a config-missing screen otherwise, so this
// `null` is never dereferenced.
export const supabase: SupabaseClient = isSupabaseConfigured
  ? createClient(SUPABASE_URL!, SUPABASE_ANON_KEY!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce',
        // Use a dedicated storage key so admin-web doesn't fight the
        // user-facing web app for the same localStorage slot when the
        // owner is signed into both on the same browser.
        storageKey: 'sb-newswave-admin-auth',
      },
    })
  : (null as unknown as SupabaseClient);
